/**
 * @功能名称: 包装axios方法返回快捷功能方法
 * @文件名称: proxyAxios.js
 * @Date: 2018/8/2 下午4:59.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 */
import axios from 'axios';

function proxyAjax(method, ...arg) {
  return new Promise(function(reslove, reject) {
    axios[method](...arg).then(function(json) {
      if (json.errcode) {
        reject(json);
      } else {
        reslove(json);
      }
    }, function(json) {
      if(json){
        reject(json)
      }
    });
  });
}

function post() {
  return proxyAjax('post', ...arguments);
};

function postSlient(url, data, config = {}) {
  config.slient = true;
  return proxyAjax('post', url, data, config);
};

function get() {
  return proxyAjax('get', ...arguments);
};

function getSlient(url, config = {}) {
  config.slient = true;
  return proxyAjax('get', url, config);

};
export {
  post,
  postSlient,
  get,
  getSlient,
};



// WEBPACK FOOTER //
// ./node_modules/bjxy-common/network/http.js